import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { CareTeamScreen } from 'screens/care-team';

export default withPermissions(CareTeamScreen, [GroupSecurity.CareTeamRead]);
